import classNames from "classnames";
import type { Mood } from "common/generator/components/mood";
import type { TextBoxJustify } from "common/generator/components/text-box-types";
import type { HasOverlayProps, HasOverlayState } from "../../smart/has-overlay-component/has-overlay-component";
import HasOverlayComponent from "../../smart/has-overlay-component/has-overlay-component";
import { HintStyle } from "./hint-style";

interface Props extends HasOverlayProps {
    readonly title?: string;
    readonly note?: string;
    readonly className?: string;

    readonly mood: Mood;
    readonly justify: TextBoxJustify;
}

interface State extends HasOverlayState {}

class HintPreviewImpl extends HasOverlayComponent<Props, State> {
    public state: State = {};

    public render(): React.ReactNode {
        const { title, mood, className, justify } = this.props;

        return (
            <HintStyle className={classNames(className, justify.toLowerCase())} data-test="app-hint" mood={mood}>
                {title !== undefined && title.length > 0 && <div className="hint-header">{title}</div>}
                <div className="hint-body">{this.props.note}</div>
            </HintStyle>
        );
    }
}

export default HintPreviewImpl;
